const ADD_NOTIFICATION = 'ADD_NOTIFICATION'
const MAX_NOTIFICATIONS = 3
const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION'

export const state = {
  notifications: [],
}

export const getters = {
  getNotifications(state) {
    return state.notifications
  },
}

export const mutations = {
  [ADD_NOTIFICATION](state, data) {
    if (state.notifications.length === MAX_NOTIFICATIONS) state.notifications.shift()

    state.notifications.push(data)
  },
  [REMOVE_NOTIFICATION](state, data) {
    state.notifications = state.notifications.filter((notification) => notification.date !== data.date)
  },
}

export const actions = {
  addNotification({ commit }, params) {
    if (!params) return

    commit(ADD_NOTIFICATION, {
      ...params,
      date: new Date().toString(),
    })
  },
  removeNotification({ commit }, params) {
    if (!params) return
    if (params.timer) clearTimeout(params.timer)

    commit(REMOVE_NOTIFICATION, params)
  },
}
